import { useEventFormFunctionalWrapperActiveSessionQuery } from '@graphql/generated';

export const useActiveSession = (eventId: string) => {
  const { data: sessionData, loading: sessionLoading } = useEventFormFunctionalWrapperActiveSessionQuery({
    variables: {
      eventByIdId: eventId,
    },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
  });

  const guestKey = sessionData?.eventById?.activeSession.guestKey;

  return { guestKey, loading: sessionLoading };
};
